// @flow
import { SubscriptionComplete } from '@views';

// Reached once the browser checkout activated the subscription (checkWebCheckout)
export default SubscriptionComplete;
